<!-- Filter Bar -->
@if (filterLoading) {
<div class="gt-filter-container">
  <div class="col">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
</div>
}

@if (!filterLoading) {
<div class="gt-filter-container ng-scope">
  <div class="col">
    <select id="ftc_schd_k_tax_year"
      [(ngModel)]="selectedTaxYear"
      (ngModelChange)="getScenarioDropDown()">
      @for (item of filteredTaxYearData; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
    </select>
  </div>
  <div class="col">
    @if (scenarioLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!scenarioLoading) {
<select id="ftc_schd_k_scenario"
     
      [(ngModel)]="selectedScenario"
      (ngModelChange)="getFilingGroupDropdown()">
      @for (item of scenarioDropDown; track $index) {
<option [ngValue]="item">{{ item.LABEL }}</option>
}
    </select>
}
  </div>
  <div class="col">
    @if (filingGrpLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!filingGrpLoading) {
<select id="ftc_schd_k_fg"
     
      [(ngModel)]="selectedFG"
      (ngModelChange)="getFilerEntityDropdown()">
      @for (item of filingGroupDropdown; track $index) {
<option [ngValue]="item">{{ item.LABEL }}</option>
}
    </select>
}
  </div>
  <div class="col">
    @if (filerEntityLoading) {
<div class="gt-filter-loading ng-hide" style="width: 140px;">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    @if (!filerEntityLoading) {
<select id="ftc_schd_k_fe"
     
      [(ngModel)]="selectedFE">
      @for (item of filerEntityDropdown; track $index) {
<option [ngValue]="item">{{ item.FILER_LE }}</option>
}
    </select>
}
  </div>
  <div class="col">
    <div class="btn btn-xs btn-success" (click)="refresh()">Filter</div>
  </div>
</div>
}

<!-- Banner (no data loaded yet) -->
@if (showBanner) {
<div class="gg-loader">
  <div class="gg-loader-text">
    <img src="assets/img/arrow-filter-sm.png" alt="Filter">
  </div>
</div>
}

<!-- Form Content -->
@if (!showBanner) {
<div style="background-color:white">
  <!-- Spinner -->
  @if (showSpinner) {
<div class="text-center" style="padding: 40px;">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  @if (!showSpinner) {
<div class="divShadow">
    <div class="table-responsive" style="position: relative;left:1px;width:100%">
      <table class="table table-striped blue">
        <thead>
          <tr align="center">
            <th>&nbsp;#&nbsp;</th>
            <th style="text-align: center;">Foreign Tax Carryover <br> Reconciliation</th>
            @for (cols of formColumns; track $index) {
<th style="width:100px;text-align: center;vertical-align: top;"
               >
              {{ cols.CODE_DISP_DESC }}
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (x of groupedFormLines; track trackByLineOrder($index, x)) {
<tr>
            <td style="font-weight:bold">{{ x.LINE_NO }}</td>
            <td><p style="width:500px;">{{ x.LINE_DESCRIPTION }}</p></td>
            @for (amts of x.items; track trackByIndex(idx); let idx = $index) {
<td
                style="height: 30px; width:100px; text-align: right;">
              <!-- Editable column (non-Totals) -->
              @if (amts.COL_DESCRIPTION !== 'Totals') {
<span>
                <input
                  [id]="'FTC_SCHDK_CRUD_' + x.LINE_ORDER + '_' + idx"
                  class="form-control custom-textbox"
                  [(ngModel)]="amts.ATTRIB_AMOUNT"
                  (ngModelChange)="addTotals()"
                  [disabled]="amts.IS_ENABLED !== 'Y'"
                  type="text"
                  (focus)="onFieldFocus($event)"
                  (blur)="onFieldBlur($event, amts, 'ATTRIB_AMOUNT')"
                  (keypress)="onFieldKeypress($event)"
                  (input)="onFieldInput($event, amts, 'ATTRIB_AMOUNT')"
                  style="text-align: right;" />
              </span>
}
              <!-- Read-only Totals column -->
              @if (amts.COL_DESCRIPTION === 'Totals') {
<span
                    [ngClass]="{'color-red': amts.ATTRIB_AMOUNT < 0}">
                {{ formatNumberWithCommas(amts.ATTRIB_AMOUNT) }}
              </span>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- ===================== Save / Reset Buttons ===================== -->
    <div class="row">
      <div class="col-md-4 col-md-offset-10">
        <button id="FTC_SCHDK_CRUD_1" class="btn btn-info btn-sm"
          type="button"
          [disabled]="!isAdmin || isSaveClicked"
          style="margin-right: 8px;"
          (click)="saveGeneralBasket()">Save</button>
        <button id="FTC_SCHDK_CRUD_2" class="btn btn-default btn-sm"
          type="button"
          [disabled]="!isAdmin"
          (click)="reset()">Reset</button>
      </div>
      <br /><br /><br />
    </div>
  </div>
}
  <br /><br /><br />
</div>
}

<!-- Confirmation Dialog (matches entity-update pattern) -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="modalConfig"
      [visible]="false"
      (confirmed)="onConfirmSave()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
